module.exports = __webpack_public_path__ + "share-dialog-cold.d3ca1387.png";